import { render, staticRenderFns } from "./SwitchThemeButton.vue?vue&type=template&id=7bfc3788&"
import script from "./SwitchThemeButton.vue?vue&type=script&lang=js&"
export * from "./SwitchThemeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports